import { createEntityReducer } from '../reducers/createEntityReducer';
const ProjectStages = createEntityReducer({
    entityName: 'projectStage',
    entityIdProperty: 'projectStageId',
    idSelector: (projectStage) => projectStage.projectStageId,
});
export default ProjectStages;
